export const MuiDataGrid = {
  styleOverrides: {
    root: {
      border: 'none',
    },
  },
};
